export default __webpack_public_path__ + "fonts/2610a4263a2448ca5b51731105af6ec6.svg";